"use client";

import { type ComponentPropsWithoutRef, forwardRef } from "react";
import { twMerge } from "tailwind-merge";
import { Icon } from "@/components/Icon";

export interface DragHandleProps extends Omit<ComponentPropsWithoutRef<"button">, "children"> {
  "aria-label": string;
  isDragging?: boolean;
}

/** Shared grip styling; the caller supplies drag sensors and keyboard handlers. */
export const DragHandle = forwardRef<HTMLButtonElement, DragHandleProps>(function DragHandle(
  { isDragging = false, className, disabled, title = "Drag to reorder. Press Space, then use arrow keys.", ...props },
  ref
) {
  return (
    <button
      {...props}
      ref={ref}
      type="button"
      disabled={disabled}
      title={title}
      data-dragging={isDragging || undefined}
      className={twMerge(
        "flex size-6 shrink-0 touch-none items-center justify-center rounded text-text-secondary cursor-grab active:cursor-grabbing hover:text-text-primary focus-visible:outline focus-visible:outline-2 focus-visible:outline-action-brand",
        isDragging && "cursor-grabbing text-action-brand",
        disabled && "cursor-not-allowed opacity-40",
        className
      )}
    >
      <Icon name="DotsSixVertical" size={16} />
    </button>
  );
});
